module.exports = __webpack_public_path__ + "media/images/programme_ambassadeur-c83ff9e2ba3d8012800d7559195d4eda.pdf";